import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

import { colors, embroideryColors } from '../mock-data/car-cover-colors';
import { initSelectedCar } from '../utils/helpers';
import { PRODUCTS_MAP } from '../constants/product';

const productHandle = window?.conspire_product?.handle;
const colorGroup = colors.find(g => g.handle === productHandle) || colors?.[0];

const TABS = [
  {
    name: 'Product Information',
    value: 'INFO',
    html: window?.conspire_product?.description
  },
  {
    name: 'Warranty',
    value: 'WARRANTY',
    html: window?.conspire_product_warranty
  },
  {
    name: 'FAQ',
    value: 'FAQ',
    html: window?.conspire_product_faq
  }
];

const embroideryProductDefaultVariant = {
  id: window?.conspire_embroidery_first_seven_letters_variant?.split(':')?.[1]
}
const embroideryProductAdditionalVariant = {
  id: window?.conspire_embroidery_additional_letters_variant?.split(':')?.[1]
}
const noLogoProductVariant = {
  id: window?.conspire_remove_logo_variant?.split(':')?.[1]
}
const flannelLiningProductVariant = {
  id: window?.conspire_flannel_lining_to_seams_variant?.split(':')?.[1]
}
const pipingProductVariants = window?.conspire_fgs_piping_product?.variants || [];

const INITIAL_STATE = {
  colorGroup,
  tabs: TABS,
  selectedColor: colorGroup?.colors[0] || "",
  selectedSecondaryColor: "",
  selectedCar: initSelectedCar(),
  selectedPipingProductVariant: pipingProductVariants?.[0],
  pipingProductVariants,
  embroideryProductVariants: {
    default: embroideryProductDefaultVariant,
    additional: embroideryProductAdditionalVariant
  },
  flannelLiningProductVariant,
  noLogoProductVariant,
  embroideryColors: embroideryColors,
  embroideryColor: embroideryColors[0],
  hasEmbroidery: "NO",
  hasNoLogo: "NO",
  embroideryText: "",
  hasFlannelLining: "NO",
  hasModification: "NO",
  modificationText: "",
  quantity: 1,
  productImageHandle: PRODUCTS_MAP[productHandle]?.imageHandle,
  productVariant: {}
};

if (window?.conspire_product?.handle === PRODUCTS_MAP['flannelguard-supreme']?.handle) {
  INITIAL_STATE.selectedSecondaryColor = colorGroup?.secondaryColors[0] || ""
}

export const useCarCoverStore = create(
  immer((set) => ({
    ...INITIAL_STATE,
    setSelectedColor: (color) =>
      set((state) => {
        state.selectedColor = color;
      }),
    setSelectedSecondaryColor: (color) =>
      set((state) => {
        const selectedPipingProductVariant = state.pipingProductVariants.find(v => v.option1 === color.name);

        state.selectedSecondaryColor = color;
        state.selectedPipingProductVariant = selectedPipingProductVariant;
      }),
    setSelectedCar: (car) =>
      set((state) => {
        state.selectedCar = car;
      }),
    setHasNoLogo: (hasNoLogo) =>
      set((state) => {
        state.hasNoLogo = hasNoLogo;
      }),
    setHasEmbroidery: (hasEmbroidery) =>
      set((state) => {
        state.hasEmbroidery = hasEmbroidery;
      }),
    setEmbroideryColor: (color) =>
      set((state) => {
        state.embroideryColor = color;
      }),
    setEmbroideryText: (text) =>
      set((state) => {
        state.embroideryText = text;
      }),
    setHasFlannelLining: (hasFlannelLining) =>
      set((state) => {
        state.hasFlannelLining = hasFlannelLining;
      }),
    setHasModification: (hasModification) =>
      set((state) => {
        state.hasModification = hasModification;
      }),
    setModificationText: (text) =>
      set((state) => {
        state.modificationText = text;
      }),
    setQuantity: (quantity) =>
      set((state) => {
        state.quantity = quantity;
      }),
    setProductVariant: (variant) =>
      set((state) => {
        state.productVariant = variant;
      }),
  }))
);
